<template>
  <div>
    <Head :title="`Editar grupo`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/groups">Grupos</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre" />
          <text-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-1/2" label="Descripcion" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="group.id !== 1" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Eliminar grupo</button>
          <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Actualizar grupo</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    group: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.group.name,
        description: this.group.description,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/groups/${this.group.id}`)
    },
    destroy() {
      if (confirm('Estas seguro que quieres eliminar este grupo?')) {
        this.$inertia.delete(`/groups/${this.group.id}`)
      }
    },
  },
}
</script>
